import { render } from "./ub-light.vue?vue&type=template&id=2f9fadba&scoped=true"
import script from "./ub-light.vue?vue&type=script&lang=js"
export * from "./ub-light.vue?vue&type=script&lang=js"

import "./ub-light.vue?vue&type=style&index=0&id=2f9fadba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9fadba"]])

export default __exports__